import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { themeClassName } from 'lib/theme/themeUtils'

const PageContent = styled.div`
  padding: ${rem(56)} 0 ${rem(40)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(80)} 0 ${rem(40)} 0;
  }
`

interface Props {
  offerList: App.OfferList
}

function CruisePageFlashOffersCarousel({ offerList }: Props) {
  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Pane>
    <PageContent>
      <Group gap={32} direction="vertical">
        <LayoutContainer>
          <Heading variant="heading2">Today’s top <i>cruise</i> offers</Heading>
        </LayoutContainer>

        <OfferListCarousel
          tileStyle="card-medium"
          overrideOfferList={offerList}
          className={themeClassName({ desktopAndUp: 'default' })}
        />
      </Group>
    </PageContent>
  </Pane>
}

export default CruisePageFlashOffersCarousel
